export const THEME_STORAGE_KEY = "settings.theme";

export function normalizeTheme(theme) {
    return theme === "light" ? "light" : "dark";
}

export function getStoredTheme() {
    return normalizeTheme(localStorage.getItem(THEME_STORAGE_KEY));
}

export function applyTheme(theme) {
    const nextTheme = normalizeTheme(theme);
    document.documentElement.setAttribute("data-theme", nextTheme);
    document.documentElement.style.colorScheme = nextTheme;
    return nextTheme;
}

export function initializeTheme() {
    return applyTheme(getStoredTheme());
}
